import Vue from 'vue'

import App from './App.vue'
import router from './router'

// FILTERS
import './filters/text-processor'

// CSS
import './assets/css/bootstrap.min.css'
import './assets/css/owl.carousel.min.css'
import './assets/css/fonts.css'

// LESS
import './assets/css/ui.less'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

